import React, { useState, useEffect } from "react";
import Loading from 'Components/Loading';
import { fromOperatorDefault, formDataDefault } from "Utils/Constants";
import Enrollment from "Pages/Enrollment/Enrollment";

import "./Enrollment.scss";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import AppLogout from "Utils/Hooks/AppLogout";
import useExternalScripts from "Utils/Hooks/useExternalScripts";
import useSession from "Utils/Hooks/useSession";
import { faro } from "@grafana/faro-react";

const EnrollmentFromServer = ({ plaidRedirect, formData = formDataDefault }) => {
  const { session } = useSession();
  const vipApi = useVipApiFetcher();
  const [fromOperator, setFromOperator] = useState(fromOperatorDefault);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdded, setIsAdded] = useState(false);
  useExternalScripts(isAdded);

  useEffect(() => {
    setIsAdded(true);
    if (!vipApi.ready) return;
    vipApi.fetch("/api/enrollment")
      .then((res) => res.json())
      .then((data) => {
        if (session.toggles.identificationInfoEnabled && plaidRedirect) {
          let bankFields = {
            bank: data.bank
          }
          setFromOperator(bankFields);
        }
        else {
          setFromOperator(data);
        }
        faro.api.pushEvent("User Starting Preferred Enrollment");
        setIsLoading(false);
      });
  }, [vipApi.ready]);

  const enrollProps = { fromOperator, formData, plaidRedirect };

  return (
    <>
      {isLoading ? <Loading /> :
        <AppLogout><Enrollment {...enrollProps} /></AppLogout>}
    </>
  );
}

export default EnrollmentFromServer;
